function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17.96 7l-10 8.889 10 8.889"
});

function SvgUiBackBold32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgUiBackBold32;